import axios from "axios";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import ChatList from "../../../Components/Host/Dashboard/ChatList";
import ChatWindow from "../../../Components/Host/Dashboard/ChatWindow";
import { fetchCmsMetaData } from "../../../Components/Utility/cmsMetaService";
import { SetMetaTags } from "../../../Components/Utility/setMetaTags";

function HostExperience() {
	 const [chatList, setChatList] = useState([]); // to store list of chats
  const [loading, setLoading] = useState(true);
   const token = localStorage.getItem("authToken");
    const [selectedChat, setSelectedChat] = useState(null);
	const [baseURL, setBaseURL] = useState(null);
const [meta,setMeta] = useState();
	 const [isChatOpen, setIsChatOpen] = useState(false);
	 const location = useLocation();
	 const chatTarget = useMemo(
		 () => location?.state?.chatTarget || null,
		 [location?.state]
	   );

  const user_id = 123; // replace with actual user_id (from props, localStorage or context)

  // fetch chat listing
  const fetchChats = useCallback(async () => {
      try {
        setLoading(true);
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE}/host/chat-users`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        // API returns data array
        setChatList(res.data?.data || []);
		setBaseURL(res.data?.base_url);
      } catch (err) {
        console.error("Error fetching chat list", err);
      } finally {
        setLoading(false);
      }
    });
  useEffect(() => {
    

    fetchChats();
  }, []);

  // --- ensure/select target without creating any local temp rows in the list ---
	const isEnsuringRef = useRef(false);
	const ensureChatWithTarget = useCallback(async () => {
	  if (!chatTarget || loading || isEnsuringRef.current) return;
	  isEnsuringRef.current = true;
  
	  try {
		// 1) Try to find in the server list
		const existing = chatList.find(
		  (c) => Number(c.user_id) === Number(chatTarget.user_id)
		);
		if (existing) {
		  setSelectedChat(existing);
		  return;
		}
  
		// 2) Not found → select a minimal "pending" selection ONLY (not added to chatList)
		const pendingSelection = {
		  user_id: chatTarget.user_id,
		  first_name: chatTarget.first_name || "",
		  last_name: chatTarget.last_name || "",
		  email: chatTarget.email || "",
		  // normalize to profile_pic to satisfy ChatWindow/ChatList
		  profile_pic: chatTarget.profile_image || chatTarget.profile_pic || null,
		  last_message: "",
		  last_message_time: null,
		  unread_count: 0,
		};
		setSelectedChat(pendingSelection);
	  } finally {
		isEnsuringRef.current = false;
	  }
	}, [chatTarget, loading, chatList]);
  
	useEffect(() => {
	  ensureChatWithTarget();
	}, [ensureChatWithTarget]);
  
	// --- called AFTER the first successful send, to refresh and then select the real thread ---
	const handleChatCreated = useCallback(
	  async ({ user_id }) => {
		await fetchChats();
  
		// small retry if backend is eventually consistent
		let found = (lst) => lst.find((c) => Number(c.user_id) === Number(user_id));
		let selected = found(window.__lastChatList__ || chatList);
  
		if (!selected) {
		  // one light retry after 400ms
		  await new Promise((r) => setTimeout(r, 400));
		  await fetchChats();
		  selected = found(window.__lastChatList__ || chatList);
		}
  
		if (selected) setSelectedChat(selected);
	  },
	  [fetchChats, chatList]
	);
  
	// keep a mirror for the retry finder above
	useEffect(() => {
	  if (typeof window !== "undefined") window.__lastChatList__ = chatList;
	}, [chatList]);
  

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
 
  }, []);


  useEffect(() => {
  ensureChatWithTarget();

  // 👇 If there’s a target and user is on mobile, open chat window directly
  if (chatTarget && window.innerWidth <= 768) {
    setIsChatOpen(true);
  }
}, [ensureChatWithTarget, chatTarget]);


  const handleSelectChat = (chat) => {
  setSelectedChat(chat);
  setIsChatOpen(true); // show chat window on mobile
};

useEffect(() => {
    const loadMeta = async () => {
      const data = await fetchCmsMetaData("chat");
      setMeta(data);
    };

    loadMeta();
  }, []);

  return (
    <>
    <section className="messagechats mssg_boxx al_bootm_spance1 user_allls us_messages"> 
		<SetMetaTags
        title= {meta?.meta_title || "Chat | Weyfarin"}
        description={meta?.meta_description || "Chat | Weyfarin"}
      
      />

	  <div className={`msg_chats_main ${isChatOpen ? "chat-open" : ""}`}>
	    {/* <div className="listing_area">
		 <div className="mn_top_area">
		  <h3>Messages(23)</h3> 
		  <div className="usr_icons_ar">
		   <span className="ic"><img src="images/settings.png" alt="" /></span>
		   <span className="ic"><img src="images/search.png" alt="" /></span>
		  </div>		  
		 </div>
		 
		 <div className="listing_mains">
		  <div className="un_litingss">
		   <div className="usr_mgs"><img src="images/ts_user.png" alt="" /></div>
		   <div className="tx_contents">
		    <h4>Lorrem Ipsum <span className="tms">12:23</span></h4>
			<p><span className="diss_tx">I wanted to know more about the experience</span>  <span className="usr_counts">5</span></p>
		   </div>
		  </div>
		  
		  <div className="un_litingss">
		   <div className="usr_mgs"><img src="images/ts_user1.png" alt="" /></div>
		   <div className="tx_contents">
		    <h4>Lorrem Ipsum <span className="tms">12:23</span></h4>
			<p><span className="diss_tx">I wanted to know more about the experience</span>  <span className="usr_counts">5</span></p>
		   </div>
		  </div>
		  
		  <div className="un_litingss">
		   <div className="usr_mgs"><img src="images/ts_user2.png" alt="" /></div>
		   <div className="tx_contents">
		    <h4>Lorrem Ipsum <span className="tms">12:23</span></h4>
			<p><span className="diss_tx">I wanted to know more about the experience</span>  <span className="usr_counts">5</span></p>
		   </div>
		  </div>
		  
		  <div className="un_litingss">
		   <div className="usr_mgs"><img src="images/ts_user.png" alt="" /></div>
		   <div className="tx_contents">
		    <h4>Lorrem Ipsum <span className="tms">12:23</span></h4>
			<p><span className="diss_tx">I wanted to know more about the experience</span>  <span className="usr_counts">5</span></p>
		   </div>
		  </div>
		  
		  <div className="un_litingss">
		   <div className="usr_mgs"><img src="images/ts_user.png" alt="" /></div>
		   <div className="tx_contents">
		    <h4>Lorrem Ipsum <span className="tms">12:23</span></h4>
			<p><span className="diss_tx">I wanted to know more about the experience</span>  <span className="usr_counts">5</span></p>
		   </div>
		  </div>
		  
		  <div className="un_litingss">
		   <div className="usr_mgs"><img src="images/ts_user1.png" alt="" /></div>
		   <div className="tx_contents">
		    <h4>Lorrem Ipsum <span className="tms">12:23</span></h4>
			<p><span className="diss_tx">I wanted to know more about the experience</span>  <span className="usr_counts">5</span></p>
		   </div>
		  </div>
		  
		  <div className="un_litingss">
		   <div className="usr_mgs"><img src="images/ts_user2.png" alt="" /></div>
		   <div className="tx_contents">
		    <h4>Lorrem Ipsum <span className="tms">12:23</span></h4>
			<p><span className="diss_tx">I wanted to know more about the experience</span>  <span className="usr_counts">5</span></p>
		   </div>
		  </div>
		  
		  <div className="un_litingss">
		   <div className="usr_mgs"><img src="images/ts_user.png" alt="" /></div>
		   <div className="tx_contents">
		    <h4>Lorrem Ipsum <span className="tms">12:23</span></h4>
			<p><span className="diss_tx">I wanted to know more about the experience</span>  <span className="usr_counts">5</span></p>
		   </div>
		  </div>
		 </div>
		 
		</div> */}

  <div className={`chat-list-wrapper ${isChatOpen ? "hide-mobile" : "show-mobile"}`}>
		<ChatList
            // chats={chatList}
            // loading={loading}
            // // onSelectChat={setSelectedChat}
			// onSelectChat={handleSelectChat}
			// baseUrl={baseURL}
			chats={chatList}
          loading={loading}
          // onSelectChat={setSelectedChat}
          onSelectChat={handleSelectChat}
          baseUrl={baseURL}
          selectedChat={selectedChat}
          />
		  </div>
		
		
		{/* <div className="msg_rights">
		 <div className="top_managses">
		  <div className="un_litingss">
		   <div className="usr_mgs"><img src="images/ts_user.png" alt="" /></div>
		   <div className="tx_contents">
		    <h4>Lorrem Ipsum </h4>
			<p><span className="diss_tx">I wanted to know more about the experience</span> </p>
		   </div>
		  </div>
		  
		  <div className="rt_dtatas">
		   <div className="dropss"><a href="javascript:void(0);"><img src="images/ellypsis.png" alt="" /></a></div>
		  </div>
		 </div>
		 
		 <div className="chats_box">
		  <div className="cnt_btnss">
		   <span className="al_btnss">Today</span>
		  </div>
		  
		  <div className="chats_mainss">
		   <div className="lft_chats">
		    <div className="usr_mgss"><img src="images/ts_user.png" alt="" /></div>
			<div className="txtx_area">
			 <p>Lorrem Ipsum <span className="tmss">12:23</span></p>
			 <div className="mssg_txt">
			  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur vitae nunc id magna egestas dapis.Quisque volutpat.
			 </div>
			</div>
		   </div>
		  </div>
		  
		  <div className="chats_mainss">
		   <div className="lft_chats rightarea">
		    <div className="rightss">
			<div className="txtx_area">
			 <p><span className="tmss">12:23</span> You</p>
			 <div className="mssg_txt">
			  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur vitae nunc id magna egestas dapis.Quisque volutpat.
			 </div>
			</div>
			</div>			
			<div className="usr_mgss"><img src="images/ts_user.png" alt="" /></div>
		   </div>
		  </div>
		  
		  <div className="cnt_btnss newmssges">
		   <span className="al_btnss">New Message</span>
		  </div>
		  
		  
		   <div className="chats_mainss">
		   <div className="lft_chats">
		    <div className="usr_mgss"><img src="images/ts_user.png" alt="" /></div>
			<div className="txtx_area">
			 <p>Lorrem Ipsum <span className="tmss">12:23</span></p>
			 <div className="mssg_txt">
			  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur vitae nunc id magna egestas dapis.Quisque volutpat.
			 </div>
			</div>
		   </div>
		  </div>
		 </div>
		 
		 <div className="cht_messages_bx">
		  <form action="">
		   <div className="frm_box">
            <div className="inp"><input  type="text" placeholder="Type a message" required="" /></div>
			<div className="boths_ic_sub">
			 <div className="ic_areaa">
			  <ul>
			   <li><img src="images/addpls.png" alt="" /></li>
			   <li><img src="images/pin.png" alt="" /></li>
			   <li><img src="images/happy-face.png" alt="" /></li>
			   <li><img src="images/imageads.png" alt="" /></li>
			  </ul>
			 </div>
			 
			 <div className="submmits">
			  <button type="submit" value="">Send</button>
			 </div>
			</div>
           </div>		   
		  </form>
		 </div>
		 
		 
		</div> */}
		<div className={`chat-window-wrapper ${isChatOpen ? "show-mobile" : "hide-mobile"}`}>
		 <ChatWindow 
		//  selectedChat={selectedChat} 
		//  baseUrl={baseURL} 
		//  onBack={() => setIsChatOpen(false)} // 👈 back to list
		selectedChat={selectedChat}
          baseUrl={baseURL}
          onChatCreated={handleChatCreated}  
          onBack={() => setIsChatOpen(false)}
		  />
		 </div>
		
	   </div>
	</section> 
    </>
  )
}

export default HostExperience